// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as Select from "../components/Select.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlState from "../player2/PlState.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as WrappedNav from "./WrappedNav.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as DelayedLoader from "../components/DelayedLoader.bs.js";
import * as WrappedSection from "./WrappedSection.bs.js";
import Button from "@mui/material/Button";
import Select$1 from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

function WrappedLayout(Props) {
  var region = Props.region;
  var playerName = Props.playerName;
  var queueId = Props.queueId;
  var tag = Props.tag;
  var loading = Props.loading;
  var children = Props.children;
  var set = TftSet.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var router = Router.use(undefined);
  var match = React.useState(function () {
        var region$1 = Belt_Option.flatMap(region, Region.fromName);
        if (region$1 !== undefined) {
          return region$1;
        } else {
          return /* Euw */0;
        }
      });
  var setRegionInput = match[1];
  var regionInput = match[0];
  React.useEffect((function () {
          var match = Belt_Option.flatMap(region, Region.fromName);
          if (match !== undefined) {
            
          } else {
            Curry._1(setRegionInput, (function (param) {
                    return PlState.getDefaultRegion(undefined);
                  }));
          }
          
        }), []);
  var match$1 = React.useState(function () {
        if (playerName !== undefined) {
          if (tag !== undefined) {
            return playerName + "#" + tag;
          } else {
            return playerName;
          }
        } else {
          return "";
        }
      });
  var setPlayerInput = match$1[1];
  var playerInput = match$1[0];
  var match$2 = React.useState(function () {
        return Belt_Option.getWithDefault(queueId, 1100);
      });
  var setQueueInput = match$2[1];
  var queueInput = match$2[0];
  var search = function (param) {
    var match;
    if (playerInput.includes("#")) {
      var split = playerInput.split("#");
      match = [
        Belt_Array.getExn(split, 0),
        Belt_Array.getExn(split, 1)
      ];
    } else {
      match = [
        playerInput,
        undefined
      ];
    }
    return router.push(Route.toString({
                    TAG: /* SetWrapped */4,
                    _0: set,
                    _1: {
                      region: regionInput,
                      playerName: match[0],
                      queueId: queueInput,
                      tag: match[1]
                    }
                  }), undefined, undefined);
  };
  return React.createElement(React.Fragment, undefined, React.createElement(AdLayout.make, {
                  children: null
                }, React.createElement(WrappedNav.make, {
                      set: set
                    }), React.createElement("div", {
                      className: "leading-snug mx-auto w-[640px]"
                    }, React.createElement(WrappedSection.make, {
                          children: "Enter your region and summoner name below to proceed."
                        }), React.createElement(WrappedSection.make, {
                          children: React.createElement("div", {
                                className: "flex justify-between items-end"
                              }, React.createElement("div", {
                                    className: "flex items-end"
                                  }, React.createElement(FormControl, {
                                        size: "small",
                                        children: null
                                      }, React.createElement(InputLabel, {
                                            variant: "standard",
                                            children: "Region"
                                          }), React.createElement(Select$1, {
                                            native: screenSize >= 4,
                                            value: Region.toApiName(regionInput),
                                            onChange: (function (e) {
                                                var v = e.target.value;
                                                return Curry._1(setRegionInput, (function (param) {
                                                              return Region.fromApiName(v);
                                                            }));
                                              }),
                                            className: "w-[65px]",
                                            variant: "standard",
                                            children: Belt_Array.map(Region.all, (function (region) {
                                                    if (screenSize >= 4) {
                                                      return React.createElement("option", {
                                                                  key: Region.toApiName(region),
                                                                  value: Region.toApiName(region)
                                                                }, Region.toName3(region));
                                                    } else {
                                                      return React.createElement(MenuItem, {
                                                                  value: Region.toApiName(region),
                                                                  children: Region.toName3(region),
                                                                  key: Region.toApiName(region)
                                                                });
                                                    }
                                                  }))
                                          })), React.createElement("div", {
                                        className: "notranslate w-[160px] pl-3"
                                      }, React.createElement(TextField, {
                                            InputLabelProps: {
                                              shrink: true
                                            },
                                            size: "small",
                                            onKeyDown: (function (e) {
                                                if (e.which === 13) {
                                                  return search(undefined);
                                                }
                                                
                                              }),
                                            autoFocus: false,
                                            label: "Summoner Name#TAG",
                                            value: playerInput,
                                            onChange: (function (e) {
                                                var v = e.target.value;
                                                return Curry._1(setPlayerInput, (function (param) {
                                                              return v;
                                                            }));
                                              }),
                                            variant: "standard"
                                          })), set % 10 === 6 ? null : React.createElement("div", {
                                          className: "pl-3"
                                        }, React.createElement(Select.make, {
                                              options: [
                                                [
                                                  1100,
                                                  "Ranked"
                                                ],
                                                [
                                                  1090,
                                                  "Normal"
                                                ],
                                                [
                                                  1160,
                                                  "Double Up"
                                                ]
                                              ],
                                              value: queueInput,
                                              setValue: (function (v) {
                                                  return Curry._1(setQueueInput, (function (param) {
                                                                return v;
                                                              }));
                                                }),
                                              toKey: (function (prim) {
                                                  return String(prim);
                                                }),
                                              fromKey: (function (id) {
                                                  return Belt_Option.getExn(Belt_Int.fromString(id));
                                                })
                                            })), React.createElement("div", {
                                        className: "pl-3"
                                      }, React.createElement(Button, {
                                            onClick: (function (param) {
                                                return search(undefined);
                                              }),
                                            variant: "contained",
                                            color: "secondary",
                                            size: "small",
                                            children: "Search"
                                          })))),
                          className: "mt-8"
                        }), children)), loading ? React.createElement(DelayedLoader.make, {}) : null);
}

var make = WrappedLayout;

export {
  make ,
  
}
/* Route Not a pure module */
